<template>
  <router-link v-bind:to="to" @click="$emit('click')">
    <slot></slot>
  </router-link>
</template>
<script>
export default {
  props: ["to"],
  emits: ["click"],
};
</script>
